import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {environment} from '@env/environment';
import {CSPostResponseModel, FinanceModel} from '@service/models';

const API_FINAL_SUBMIT_URL = environment.apiUrl + '/deposit/account/applications/core/onboard';
const API_COLLATERAL_URL = environment.apiUrl + '/finance';
const API_DEPOSIT = environment.apiUrl + '/deposit';

@Injectable({
    providedIn: 'root'
})
export class FinanceService {
    finalSummitCredentials = new Subject<any>();
    otherOwners$ = new Subject<any>();
    controllingManager$ = new Subject<any>();
    credentials: any = '';
    private customHttpClient: HttpClient;

    constructor(private http: HttpClient, backend: HttpBackend) {
        this.customHttpClient = new HttpClient(backend);
        this.finalSummitCredentials.subscribe(data => {
            this.credentials = data;
        });
    }

    financeSubmit(_applicationId: number, finance: FinanceModel): Observable<CSPostResponseModel> {
        return this.http.put<CSPostResponseModel>(API_FINAL_SUBMIT_URL + `/${_applicationId}`, finance);
    }

    getFileContent(url) {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'text/html');
        return this.customHttpClient.get(url, {headers, responseType: 'text'});
    }

    oldFinanceSubmit(_applicationId: number, finance: FinanceModel): Observable<CSPostResponseModel> {
        return this.http.put<CSPostResponseModel>(API_COLLATERAL_URL + `/${_applicationId}`, finance);
    }

    proceedOnlineBanking(_applicationId: number): Observable<any> {
        return this.http.get<any>(API_DEPOSIT + `/account/applications/registerUrl/${_applicationId}`);
    }

    internalTransfer(applicationId, data) {
        return this.http.post<any>(`${environment.apiUrl}/payment/internal/transfer/${applicationId}`, data);
    }

    externalACHTransfer(applicationId, data) {
        return this.http.post<any>(`${environment.apiUrl}/payment/ach/details/${applicationId}`, data);
    }

    getInternalAccounts(applicationId) {
        return this.http.get<any>(`${environment.apiUrl}/payment/internal/accounts/${applicationId}`);
    }


    fetchPlaidLinkedAccounts(applicationId: number) {
        return this.http.get<any>(
            `${environment.apiUrl}/payment/external/accounts/${applicationId}`);
    }

    exchangePublicTokenForAccounts(applicationId, publicToken) {
        return this.http.get<any>(`${environment.apiUrl}/payment/external/accounts/${applicationId}?publicToken=${publicToken}`);
    }


    createPlaidLinkToken(applicationId) {
        return this.http.post<any>(`${environment.apiUrl}/payment/create/linkToken/${applicationId}`, {});
    }

    postPreRegistration(applicationId, data) {
        return this.http.post<any>(`${environment.apiUrl}/deposit/account/applications/registerUser/${applicationId}`, data);
    }

    /**
     * Post To Core CoApplicant
     */
    postToCoreCoBo(applicationId) {
        return this.http.put<any>(API_DEPOSIT + `/account/applications/${applicationId}/core/addjointowner`, {}, {
        });
    }

    getDirectDepositUUID(applicationId: number, offerId: any) {
        const body = {
            depositAccountApplicationOffersId: offerId
        };
        return this.http.post(`${environment.apiUrl}/directdeposit/application/${applicationId}/url`, body);
    }
}
